export default __webpack_public_path__ + "static/media/profile-user.35610366.png";